import * as utils from '@/utils/form.js'

export default {
  name: "costDialog",
  props: ['campaignId'],
  data() {
    return {
      dialogFormVisible: false,
      form: {
        tableData: [],
      },
      campaignObj: {},
      title: '',
      totalCampaign: 0,
    }
  },
  mounted() {

  },
  methods: {
    validateTable: function () {
      return [
        {required: true, message: '请输入', trigger: 'blur'},
        {validator: utils.validateInt, trigger: 'blur'}
      ]
    },
    handleShow: function (value) {
      this.dialogFormVisible = value
      if (value) {
        // console.log(this.$attrs)
        this.campaignObj = this.$attrs.firstData
        this.getCampaignValue()
        if(this.form.tableData.length == 0){
          this.tableHeaderInit()
        }
      }
    },
    //获取日限额
    getCampaignValue: function () {
      // console.log(this.$attrs)
      let params = {
        campaignId: this.campaignObj.campaignId,
        taskId: this.$attrs.data?this.$attrs.data.id : this.campaignObj.taskId
      }
      api.getCampaignBudgetById(params).then(res => {
        if (res.data.code == 200) {
          this.totalCampaign = res.data.data
          this.title = this.campaignObj.campaignName + '日限额:' + this.totalCampaign.budget + '元'
          if(this.totalCampaign.adCost || this.totalCampaign.crowdCost){
            this.tableValueInit()
          }
        }
      })
    },
    tableHeaderInit: function () {
      this.form.tableData = []
      for (let i = 0; i < 24; i++) {
        let start = i + ":00-" + (i + 1) + ":00"
        let obj = {
          title: start,
          value: '',
        }
        this.form.tableData.push(obj)
      }
    },
    tableValueInit:function(){
      let tableValue = null
      if (this.$attrs.type == "adgroupOperate") {
        tableValue = this.totalCampaign.adCost.split(',')
      } else {
        tableValue = this.totalCampaign.crowdCost.split(',')
      }
      this.form.tableData.forEach((item,index)=>{
        item.value = tableValue[index]
      })
    },
    submitHandle: function () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let total = 0, data = ''
          this.form.tableData.forEach(item => {
            total += item.value * 1
          })
          // console.log('24个小时总数：', total)
          if (total > this.totalCampaign) {
            this.$message.warning('24个小时的数值加起来不得超过日限额')
          } else {
            data = this.form.tableData.map(item => {
              return item.value
            }).join(',')
            this.$emit('costDialogHandle', data)
            this.handleShow(false)
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/recommend/automaticPutin/intellPromotion/component/nodeItem/costDialog/costDialog.js